import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'sp-base-header',
    templateUrl: './sp-base-header.component.html',
    styleUrls: ['./sp-base-header.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpBaseHeaderComponent {}
